import { useSwipeable } from "react-swipeable";
import { Col, Row } from "react-styled-flexboxgrid";

import NoIncidents from "./NoIncidents";

import Box from "../../Global/Atomics/Box";
import IncidentCard from "../../Global/Widgets/Cards/IncidentCard";

import { TSerializedIncident } from "../../../api/types";
import { useResponsiveContext } from "../../../contexts/ResponsiveContext";

type TProps = {
    maxTab: number;
    tab: number;
    setTab: (num: number) => void;
    data: TSerializedIncident[];
    isError: boolean;
}

const IncidentList = ({ data, maxTab, tab, setTab, isError }: TProps) => {
    const [viewMode] = useResponsiveContext();

    const isMobile = viewMode === 'mobile';

    const handlers = useSwipeable({
        onSwipedLeft: () => tab < maxTab - 1 && setTab(tab + 1),
        onSwipedRight: () => tab > 0 && setTab(tab - 1),
    });

    if (data?.length === 0 || isError) {
        return <NoIncidents setTab={setTab} tab={tab} maxTab={maxTab} />;
    }

    return (
        <Box {...handlers}>
            <Row>
                {data?.map((incident, idx: number) => {
                    let lastItem = idx === data.length - 1;

                    // Add padding only on last row
                    for (let i = 0; i <= data.length; i++) {
                        if (Math.ceil((idx + 1) / (isMobile ? 1 : 3)) === Math.ceil(data.length / (isMobile ? 1 : 3))) {
                            lastItem = true;
                        }
                    }

                    return (
                        <Col xs={12} md={4} key={idx}>
                            <Box padding={`${lastItem ? '0 0 25vh 0' : 'initital'}`} height="100%">
                                <IncidentCard
                                    key={idx}
                                    categoryTitle={incident.categoryTitle}
                                    incidentId={incident.incidentId}
                                    incidentTitle={incident.incidentTitle}
                                    incidentDescription={incident.incidentDescription}
                                    section={incident.section}
                                    lat={incident.lat}
                                    lng={incident.lng}
                                    statusLevel={incident.statusLevel}
                                    date={incident.date}
                                    watchListId={incident.watchListId}
                                    openedBy={incident.openedBy}
                                    callerId={incident.callerId}
                                    icon={incident.icon}
                                />
                            </Box>
                        </Col>
                    );
                })}
            </Row>
        </Box>
    );
};

export default IncidentList;
